/**
 * Query keys do PLANO DE LOCAÇÃO no CRM (contrato vivo pós-ganho).
 *
 * A raiz é `["rental-plan"]` de propósito: é o prefixo que os hooks antigos
 * (`QK_RENTAL_*` em `apps/crm/src/hooks/useRental*.ts`) e o `invalidates` do
 * convert-lead já usam — invalidar `["rental-plan"]` ou
 * `["rental-plan", "contract-invoices"]` alcança estas chaves também.
 */
import { tuple } from "./core";

const root = ["rental-plan"] as const;

export const locacao = {
  all: root,
  /** Fatura de UMA competência do contrato (o card mostra a corrente). */
  faturaDaCompetencia: (contractId: string | null | undefined, referenceMonth: string) =>
    tuple(root, "contract-invoices", contractId, "month", referenceMonth),
  /** Previsão da fatura de UMA competência (`rental_billable_amount`). */
  valorDaCompetencia: (contractId: string | null | undefined, referenceMonth: string) =>
    tuple(root, "contract", "month-amount", contractId, referenceMonth),
} as const;
